<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Add guest names</h5>
                <a class="close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">

                <div *ngIf="error" class="alert alert-danger" style="color: white;">{{error}}</div>

                <p class="mb-2 fs-4">A Spa Room at Ffolkes includes FFOLKESPA Thermal Spa access throughout your stay.</p>
                <p class="mb-4 fs-4">Please add the full guest names below. 15+ only.</p>


                <div class="row" *ngFor="let guest of guests; let idx = index">
                    <div class="col-1">{{idx+1}}</div>
                    <div class="col-5">
                        <div class="form-group">
                            <input
                                placeholder="First name"
                                class="form-control"
                                type="text"
                                name="firstname"
                                [(ngModel)]="guest.first_name">
                        </div>

                    </div>
                    <div class="col-6">
                        <input
                        placeholder="Surname"
                        class="form-control"
                        type="text"
                        name="surnname"
                        [(ngModel)]="guest.last_name">

                    </div>
                </div>

                <button type="button" class="btn btn-block btn-primary" (click)="confirm()">Submit</button>

            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade show modal-slide-show"></div>
